// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3317431a","453":"68693753","455":"9adbb07a"}[chunkId] + ".chunk.js";
};